import { fetchWithAuth } from "../config/axios";

export interface OnboardingStepResponse {
    step_number: number;
    step_code: string;
    status: "completed" | "skipped" | "pending" | null;
}

export interface OnboardingResponse {
    is_onboarding_enabled: boolean;
    steps: OnboardingStepResponse[];
}

export async function getOnboardingProgress(): Promise<OnboardingResponse> {
    const url = new URL(import.meta.env.VITE_CHORIPAN_URL + "/portal-onboarding").toString();
    const response = await fetchWithAuth<OnboardingResponse>(url);
    return response.data;
}

export async function disableOnboarding(): Promise<OnboardingResponse> {
    const url = new URL(import.meta.env.VITE_CHORIPAN_URL + "/portal-onboarding/disable").toString();
    const response = await fetchWithAuth<OnboardingResponse>(url, {
        method: "PATCH",
    });
    return response.data;
}

export async function updateOnboardingStep(
    step_code: string,
    status: "completed" | "skipped" | "pending",
): Promise<OnboardingResponse> {
    const url = new URL(import.meta.env.VITE_CHORIPAN_URL + "/portal-onboarding/step").toString();
    const response = await fetchWithAuth<OnboardingResponse>(url, {
        method: "PATCH",
        data: { step_code, status },
    });
    return response.data;
}
